import css from 'styled-jsx/css';

const staticStyles = css`
  .WazzupPage {
    width: 100%;
    height: calc(100vh - 102px);
    min-height: 320px;
    display: flex;
    justify-content: center;
    align-items: center;

    &__iframe {
      min-width: 0;
      border: 0;
    }

    &__auth {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 16px;
      align-items: center;
    }
  }
`;

export { staticStyles };
